module.exports = __webpack_public_path__ + "static/media/home3_bg1.651a37d7.png";